/**
 * Get environment
 * @returns {string}
 */
export let env = () => {
  let env = location.hostname.split('.');

  // Temp. fallback for old build/links
  if (location.href.indexOf('nsoft') > -1) {
    const hostname = location.hostname.split('-');
    env = hostname[1] ? hostname[1].split('.') : '';
  }

  if (location.href.indexOf('localhost') > -1) {
    return 'staging';
  }

  return env && (['staging', 'dev'].indexOf(env[0]) >= 0) ? env[0] : 'production';
};



// WEBPACK FOOTER //
// environment.js